export default "__VITE_ASSET__94759425__"